export default "__VITE_ASSET__CYflO$Da__"